import BaseAPIService from '../base/base-api-service';
import ProductModel from 'src/model/product.model';

class FrequentlyPurchasedService extends BaseAPIService<ProductModel> {
  public endpoint: string = '/navapp/v1/frequentProducts';

  constructor() {
    super(ProductModel);
  }

  public getProducts(size: number = 5): Promise<ProductModel[]> {
    return this.getByParams(this.endpoint, { size });
  }
}

const frequentlyPurchasedServiceInstance = new FrequentlyPurchasedService();
Object.freeze(frequentlyPurchasedServiceInstance);

export default frequentlyPurchasedServiceInstance;
